import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import FigureCaption from "../../components/LdsFigureCaption";
import Scans from "../../assets/module-1/1-3-4-scans.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.3.4 Kinetics of Amyvid Brain Uptake
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 2 minutes</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12 col-md-6">
              <ul>
                <li>
                  Amyvid is distributed to the brain in both cognitively healthy
                  patients and in patients diagnosed with AD<sup>1</sup>
                </li>
                <li>
                  The radiopharmaceutical is washed out from the cerebellum of
                  both patient groups but is selectively retained in cortical
                  target regions of the patients with β-amyloid plaques
                  <sup>1</sup>
                </li>
                <li>
                  Image interpretation is based upon the distribution of
                  radioactive signals within the brain; clinical information is
                  not a component of the image assessment<sup>2</sup>
                </li>
                <li>
                  Images are designated as positive or negative by comparing the
                  radioactivity in cortical gray matter with activity in the
                  adjacent white matter<sup>2</sup>
                </li>
                <li>
                  This determination is made only in the cerebral cortex; the
                  signal uptake in the cerebellum does not contribute to the
                  scan interpretation<sup>2</sup>
                </li>
              </ul>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className="blue-rounded-border p-3">
                <h2 className="h5 b text-center mt-3">
                  Concentration of Amyvid Present at 50-60 Minutes Following
                  Administration
                </h2>
                <FigureCaption
                  noCollapse={true}
                  className="figcaption-no-border align-items-center flex-column d-flex"
                  textContent={
                    <>
                      <p className="text-center" style={{ fontSize: "14px" }}>
                        The images above compare the concentration of Amyvid
                        present at 50-60 minutes following administration in the
                        brain of a healthy volunteer (left) and the brain of a
                        patient with Alzheimer’s disease (right).
                      </p>
                    </>
                  }
                >
                  <LdsImage
                    src={Scans}
                    alt="Two brain scans comparing Amyvid concentration at 50-60 minutes following administration. The left scan is of a healthy volunteer, and the right scan is of a patient with Alzheimer's disease, showing a higher concentration of Amyvid in the Alzheimer's patient."
                    style={{ maxWidth: "500px" }}
                    className=""
                  />
                </FigureCaption>
              </div>
              <p className="mt-1" style={{ fontSize: "11px" }}>
                ©2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data
                on file, Lilly Research Laboratories AMY20121001S
              </p>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-3", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-5", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Wong DF, et al. <em>J Nucl Med.</em> 2010;51(6):913-920.
              </li>
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_3;
